import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import { Card } from 'antd';
import WorkPageHeader from './WorkPageHeader';

/**
 * قالب یکدست صفحات لیست/تنظیمات ماژول کار
 */
const WorkListPage = ({
  title,
  subtitle,
  icon,
  headerExtra,
  children,
  footer = null,
  bodyClassName = '',
}) => (
  <MainLayout>
    <div style={{ fontFamily: 'CustomFont' }}>
      <Card className="shadow-xl border-0 work-page-card" bodyStyle={{ padding: 0 }}>
        <WorkPageHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          headerExtra={headerExtra}
        />
        <div className={`p-6 work-page-body rounded-b-xl ${bodyClassName}`.trim()}>
          {children}
        </div>
      </Card>
      {footer}
    </div>
  </MainLayout>
);

export default WorkListPage;
